export enum UniversityEntranceQualificationType {
  UNIVERSITY_ENTRANCE_DIPLOMA_FROM_ABROAD = 'University entrance diploma from abroad',
  HIGH_SCHOOL_DIPLOMA_MATURA = 'Abitur / Matura',
  SUBJECT_SPECIFIC_HIGH_SCHOOL_DIPLOMA = 'fachgebundenes Abitur',
  UNIVERSITY_OF_APPLIED_SCIENCES_ENTRANCE_QUALIFICATION = 'Fachhochschulreife',
  MASTERS_CERTIFICATE = 'Meisterbrief',
  APPRENTICESHIP_WITH_PRACTICAL_EXPERIENCE = 'Apprenticeship with practical experience',
  STATE_CERTIFIED_TECHNICIAN_OR_STATE_CERTIFIED_BUSINESS_ECONOMIST = 'staatlich geprüfte(r) TechnikerIn oder staatlich geprüfte(r) BetriebswirtIn',
}
